module.exports = __webpack_public_path__ + "img/lifechamps-file.fa3370e9.svg";